// Copyright (c) Jonathan Ferraz.
// Licensed under the MIT license.

import media from 'assets/styles/query';
import styled from 'styled-components';

export const Container = styled.div`
  position: relative;
  width: 100%;
  margin-top: 500px;
  margin-bottom: 180px;

  ${media.lessThan('medium')`
    margin-top: 150px;
    margin-bottom: 100px;
  `}
`;

export const Content = styled.div`
  padding: 60px 40px;
  z-index: 10;

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;

    textarea {
      width: 100%;
      flex-shrink: 0;
      border-radius: 13.67px;
      border: 1.367px solid rgba(252, 222, 134, 0.15);
      background: rgb(13 13 14 / 50%);
      padding: 20px;
      outline: none;
      color: #fff;
      font-family: SF Pro Text;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20.505px;
      letter-spacing: -0.308px;
      backdrop-filter: saturate(120%) blur(30px);
      overflow: hidden;
      resize: none;

      &::placeholder {
        color: #fff;
        opacity: 0.5;
      }
    }

    input {
      width: 100%;
      height: 56.046px;
      flex-shrink: 0;
      border-radius: 13.67px;
      border: 1.367px solid rgba(252, 222, 134, 0.15);
      background: rgb(13 13 14 / 50%);
      padding: 0px 20px;
      outline: none;
      color: #fff;
      font-family: SF Pro Text;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20.505px; /* 133.333% */
      letter-spacing: -0.308px;
      backdrop-filter: saturate(120%) blur(30px);

      &::placeholder {
        color: #fff;
        opacity: 0.5;
      }

      &:focus {
        &::placeholder {
          opacity: 1;
        }
      }
    }
  }

  ${media.lessThan('small')`
    padding: 40px 30px;

    input {
      width: 100%;
    }
  `}
`;

export const Footer = styled.footer`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  margin-top: 40px;

  button {
    padding: 8px 16px;
    border-radius: 12.951px;
    border: none;
    background: linear-gradient(180deg, #f09d3a 0%, #fcdd85 100%);

    transition: all.3s ease-in-out;

    span {
      font-family: SF Pro Display;
      font-size: 18.432px;
      font-style: normal;
      font-weight: 500;
      line-height: 16px;
      /* letter-spacing: -0.369px; */
      color: #000;
    }

    &:disabled {
      padding: 8px 16px;
      pointer-events: none;
      user-select: none;
      border-radius: 12.951px;
      background: linear-gradient(114deg, #c3c3c3 34.83%, #f1a341 110.28%);

      span {
        background: linear-gradient(
          146deg,
          rgba(0, 0, 0, 1) 0%,
          rgba(0, 0, 0, 1) 100%
        );
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }

    &:not(:disabled) {
      &:hover {
        cursor: pointer;
      }

      &:active {
        transform: scale(0.98);
      }
    }
  }

  ${media.lessThan('medium')`
    padding: 0 0px;
    margin-top: 0px;
  `}
`;

export const Wrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  margin-top: 125px;

  svg {
    position: absolute;
    margin-top: -350px;
    margin-left: -100px;
    /* margin-left: calc(100% - 1300px); */
    width: 100%;
    min-width: 1200px;
    transform: scale(0.7);
    z-index: 4;
  }

  > img {
    position: absolute;
    bottom: 20px;
    right: 0px;
    transform: scale(1.05);
    z-index: 6;
  }

  ${media.lessThan('large')`
    svg {
      margin-left: calc(100% - 1250px);
      transform: scale(0.6);
    }
  `}

  ${media.lessThan('medium')`
     > img {
      bottom: -125px;
    }
  `}
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1.3fr;
  grid-template-rows: repeat(2, 1fr);
  grid-column-gap: 20px;
  grid-row-gap: 20px;

  ${media.lessThan('medium')`
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: repeat(2, 1fr) 1.5fr;

  `}
`;

export const RowOneUpper = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  z-index: 10;

  ${media.lessThan('medium')`
    grid-area: 3 / 1 / 4 / 2;
    margin-top: -30px;
    height: 250px;

  `};
`;

export const RowOne = styled.div`
  grid-area: 1 / 1 / 3 / 2;
  z-index: 2;

  ${media.lessThan('medium')`
    height: calc(100% + 30px);
    grid-area: 3 / 1 / 4 / 2;
    margin-top: -30px;
    margin-bottom: 105px;
    z-index: 7;
  `};
`;

export const RowTwoUpper = styled.div`
  grid-area: 1 / 2 / 2 / 3;
  z-index: 5;

  div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    h1 {
      color: #fff;
      text-align: center;
      font-family: SF Pro Display;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px;
      letter-spacing: 0.216px;
      margin-bottom: 12px;
    }
  }

  ${media.lessThan('medium')`
    grid-area: 2 / 1 / 3 / 2;

    div {
      h1 {
        margin-top: -40px;
        margin-left: unset;
      }

      figure {
        padding: 0 10px;

        img {
          margin-left: -5px;
          width: 100%;
        }
      }
    }
  `};
`;

export const RowTwo = styled.div`
  grid-area: 1 / 2 / 2 / 3;

  ${media.lessThan('medium')`
    grid-area: 2 / 1 / 3 / 2;

    margin-top: -30px;
    height: 100%;

  `};
`;

export const RowThree = styled.div`
  grid-area: 2 / 2 / 3 / 3;
  z-index: 5;

  div {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;

    h1 {
      margin-top: 40px;
      margin-bottom: 40px;
      color: #fcdd85;
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 28px; /* 116.667% */
      letter-spacing: 0.216px;

      strong {
        color: #898a8f;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px;
        letter-spacing: 0.216px;
      }
    }

    figure {
      margin: -4px;
      padding: 0 20px;

      img {
        width: 100%;
      }
    }
  }

  ${media.lessThan('medium')`
    grid-area: 1 / 1 / 2 / 2;
    margin-bottom: 30px;

    div {
      height: fit-content;

      h1 {
        margin-top: 40px;
        margin-bottom: 30px;
      }
    }
  `};
`;
